import { IApplicationState } from '../../../../types/types';
import { getAuthUser } from './getAuthUser';

export const getAuthUserAllowCardColorCount = (
    state: IApplicationState
): number => {
    const user = getAuthUser(state);
    return user.allowCardColorCount;
}
